/** @jsxImportSource @emotion/react */

import { footerAnalytics } from '../../analyticsConsts';
import footerData from '../../mocks/data/footer';
import publicPath from '../../utils/publicPath';
import ExternalLink from '../ExternalLink';
import useStyles from './styles';

const { FOOTER_WRAPPER, FOOTER_CTA } = footerAnalytics;

const Footer = () => {
  const styles = useStyles();

  const { links } = footerData;
  return (
    <footer css={styles.footerWrapper} id={FOOTER_WRAPPER}>
      <div css={styles.top}>
        <div>
          <ul css={styles.list}>
            {links &&
              links.length > 0 &&
              links.map((link, index) => {
                return (
                  <li key={index}>
                    <ExternalLink
                      id={`${
                        link.id ? link.id : FOOTER_CTA.concat(`-${index}`)
                      }`}
                      css={styles.link}
                      className={link.className}
                      href={link.url}
                      download={link.isDownload}
                    >
                      {link.text}
                      {link.isDownload && (
                        <span css={styles.pdfDownload}>
                          (downloads pdf file)
                        </span>
                      )}
                    </ExternalLink>
                  </li>
                );
              })}
          </ul>
        </div>
        <div css={styles.middle}>
          <ul css={styles.icons}>
            <li>
              <img
                src={publicPath(`/images/common/footer-1.png`)}
                width="100%"
                alt="footer-icon"
              />
            </li>
            <li>
              <img
                src={publicPath(`/images/common/footer-2.png`)}
                width="100%"
                alt="footer-icon"
              />
            </li>
            <li>
              <img
                src={publicPath(`/images/common/footer-3.png`)}
                width="100%"
                alt="footer-icon"
              />
            </li>
          </ul>
        </div>
      </div>

      <div css={styles.bottom}>
        The Football Association © 2001 - {new Date().getFullYear()} - All
        Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
